import React from "react";
import CloseIcon from "../../Assets/Icons/closeIcon.svg";

export default function TeamMemberCard(props) {
  return (
    <div className="w-[16.5rem] py-4 px-4 border-[1px] bg-white rounded-[12px] border-[#E5E7EB]">
      {props.closeicon && (
        <div className="flex items-end justify-end">
          <img src={props.closeicon} />
        </div>
      )}
      <div className="flex items-center justify-center mt-2">
        <img className="w-[4.5rem] h-[4.5rem]" src={props.img} />
      </div>
      <div className="flex items-center justify-center gap-1 flex-col mt-3">
        <h2 className="text-[1rem] font-[500] text-[#111928]">{props.name}</h2>
        <p className="text-[0.90rem] text-[#6B7280]">{props.location}</p>
        <p className="text-[0.85rem] text-[#942A27] font-[500]">
          {props.position}
        </p>
        <p className="text-[0.80rem] text-[#111928]">{props.hourstext} <span className="text-[#942A27] font-[600]">{props.hours}</span></p>
      </div>
      {props.btntext && (
        <button
          className="w-full py-2 border-[1px] rounded-[8px] border-[#E5E7EB] text-[0.90rem] text-[#1F2A37] mt-5"
          onClick={() => props?.handleClick && props?.handleClick()}
        >
          {props.btntext}
        </button>
      )}
    </div>
  );
}
